import React from 'react';

import DialogContent from '@mui/material/DialogContent';

import Box from '@mui/material/Box';

import Dialog from 'src/components/ui/Dialog';
import Image from 'src/components/ui/Image';
import DialogTitle from 'src/components/ui/DialogTitle';
import Typography from 'src/components/ui/Typography';

import type { ModalProps } from 'src/hooks/useModalOpenState';
import { styledComponent } from 'src/utils/styled';

const StyledDialog = styledComponent(Dialog)`
    .MuiDialog-paper {
        width: auto;
        overflow: hidden;
        max-height: 90%;
    }
`;

const StyledDialogTitle = styledComponent(DialogTitle)`
    justify-content: center;
    position: relative;
    padding: 1rem 3rem;
    .MuiTypography-root {
        font-size: 1.125rem;
    }
    .MuiIconButton-root {
        position: absolute;
        right: 1rem;
    }
`;

const StyledDialogContent = styledComponent(DialogContent)`
    padding: 0;
`;

const StyledImage = styledComponent(Image)`
    display: block;
    margin: 0 auto;
    width: 100%;
`;

interface Props extends ModalProps {
    feeScaleFile: string;
    feeScaleFileName: string;
}

const FeeScaleModal: React.FC<Props> = ({ feeScaleFile, feeScaleFileName, open, onClose }) => {
    const isPdf = feeScaleFile.includes('pdf');

    return (
        <StyledDialog onClose={onClose} open={open} fullWidth>
            <StyledDialogTitle onClose={onClose}>
                <Box display="flex" flexDirection="row" alignItems="center">
                    <Typography variant="h3">{feeScaleFileName}</Typography>
                </Box>
            </StyledDialogTitle>
            <StyledDialogContent>
                {isPdf ? (
                    <iframe
                        title={feeScaleFileName}
                        src={`https://docs.google.com/gview?url=${feeScaleFile}&embedded=true`}
                        width="37.5rem"
                        height="50rem"
                        frameBorder={0}
                    />
                ) : (
                    <StyledImage src={feeScaleFile} alt={feeScaleFileName} />
                )}
            </StyledDialogContent>
        </StyledDialog>
    );
};

export default FeeScaleModal;
